<div class="unauthorized-message">
    <div>
        You are not authorized to access this page. Please request access on <a target="_blank" href="https://myaccess2.corteva.com/">MyAccess</a>.
    </div>
</div>